import { translateText } from "../../i18n/translate-text.js";
import { exitText } from "../../../i18n/text/fullscreen.js";
import { captionsOffText, captionsOnText, exitPipText, fullscreenText, pausedText, pipText, playingText } from "../../../i18n/text/status.js";
import { labelText, mutedText } from "../../../i18n/text/volume.js";
//#region src/core/ui/indicator/labels.ts
const DEFAULT_INPUT_INDICATOR_LABELS = {
	muted: translateText(mutedText),
	volume: translateText(labelText),
	captionsOn: translateText(captionsOnText),
	captionsOff: translateText(captionsOffText),
	paused: translateText(pausedText),
	playing: translateText(playingText),
	fullscreen: translateText(fullscreenText),
	exitFullscreen: translateText(exitText),
	pictureInPicture: translateText(pipText),
	exitPictureInPicture: translateText(exitPipText)
};
/** Maps i18n indicator keys to {@link InputIndicatorLabels} for status / volume feedback. */
function createInputIndicatorLabels(translator) {
	return {
		muted: translator(mutedText),
		volume: translator(labelText),
		captionsOn: translator(captionsOnText),
		captionsOff: translator(captionsOffText),
		paused: translator(pausedText),
		playing: translator(playingText),
		fullscreen: translator(fullscreenText),
		exitFullscreen: translator(exitText),
		pictureInPicture: translator(pipText),
		exitPictureInPicture: translator(exitPipText)
	};
}
//#endregion
export { DEFAULT_INPUT_INDICATOR_LABELS, createInputIndicatorLabels };

//# sourceMappingURL=labels.js.map